import React from 'react';
import { map, get, isEmpty } from 'underscore';
import { CommandButton } from '@fluentui/react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';

import { YourMetrics, Metrics } from '../../enums/metrics';
import { formatChangeRatio, formatDecimal } from '../../utils/format';

export const KPIColumn = ({
  i18n,
  logger,
  logContext,
  selectedMetricIndex,
  setSelectedMetricIndex,
}) => {
  const { key, value } = YourMetrics[selectedMetricIndex] || {};

  return {
    key,
    name: i18n.getString(value),
    fieldName: `${key}.CurrentValue`,
    className: 'qi-column-kpi',
    headerClassName: 'qi-header-kpi',
    helpTopic: 'Pop_BA_SearchInsights_ClickImpSpend',
    minWidth: 160,
    sortable: true,
    isMultiline: true,
    isResizable: true,
    onRender: (item, index, column) => {
      const currentValue = formatDecimal(i18n, get(item, [column.key, 'CurrentValue']));
      const changeRatio = formatChangeRatio(i18n, get(item, [column.key, 'ChangeRatio']));
      return (
        <span>
          {isEmpty(changeRatio) ? currentValue : i18n.getString(_TL_('{{value}} ({{ratio}})'), {
            value: currentValue,
            ratio: changeRatio,
          })}
        </span>
      );
    },
    // eslint-disable-next-line react/prop-types
    onRenderHeader: ({ column }) => (
      <div className="qi-header-metrics">
        <span className="qi-metrics-name">{column.name}</span>
        <CommandButton
          className="qi-metrics-dropdown"
          ariaLabel={i18n.getString(_TL_('Select your performance in this column'))}
          menuProps={{
            items: map(YourMetrics, (metric, index) => ({
              key: metric.key,
              text: i18n.getString(metric.value),
              onClick: () => {
                logger.log(logContext, 'MetricsPicker', 'Selection', Metrics[index], Metrics[selectedMetricIndex]);
                setSelectedMetricIndex(index);
              },
            })),
          }}
        />
        <HelpIcon topic={column.helpTopic} ariaLabel={i18n.getString(_TL_('Learn more about clicks, impressions, or spend'))} />
      </div>
    ),
  };
};
